import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import {
  GET_IMEI,
  GET_IMEI_BY_ID,
  UPDATE_GLOBAL_IMEI,
  UPDATE_GLOBAL_IMEI_STATUS,
} from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getGlobalImeiCode = () => async (dispatch) => {
  try {
    const res = await axios.get("globalImei/all");
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_IMEI, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const getGlobalImeiCodeById = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`globalImei/${params.id}`);
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_IMEI_BY_ID, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
export const updateGlobalImei = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("globalImei/update", formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_GLOBAL_IMEI, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updateGlobalImeiStatus = (formData) => async (dispatch) => {
  try {
    // const updatedFormData = { ...formData, id: formData._id };
    // console.log("formdata updateCustomerStatus:", id, status);

    const res = await axios.post("globalImei/update", formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_GLOBAL_IMEI_STATUS, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // Use the global error message function
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
